import { IQueryContext } from 'framework/context/IQueryContext';
import { ICustomerAccountLine, ICustomerAccountLineQueryMetadata, IQueryResultWithMetadata, IUnhandledCustomerAccountLinesQueryParams } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<ICustomerAccountLine, ICustomerAccountLineQueryMetadata>, IUnhandledCustomerAccountLinesQueryParams>
>(undefined as any);
